'use client';

import { useCallback } from 'react';

import { useUserSession } from '@libs/common-next';

import { PROFILE_DATA } from '../../../constants';

export type UseManagePaymentResult = Readonly<{
    syncProfileAfterPaymentChange: () => Promise<void>;
}>;

export function useManagePayment(): UseManagePaymentResult {
    const { updateProfileData } = useUserSession();

    const syncProfileAfterPaymentChange = useCallback(async () => {
        await Promise.all([updateProfileData?.(PROFILE_DATA.PAYMENTS), updateProfileData?.(PROFILE_DATA.ADDRESSES)]);
    }, [updateProfileData]);

    return { syncProfileAfterPaymentChange };
}
